// Hover-revealed card toolbar: Download CSV + Expand icons.
// Put className="trg-tool-host" (position:relative) on the card, and render
// <CardTools onCsv={...} onExpand={...} /> inside it.
import { useEffect } from "react";

export const IconExpand = () => (
  <svg viewBox="0 0 16 16" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round">
    <polyline points="3 9 3 13 7 13" /><polyline points="13 7 13 3 9 3" />
    <line x1="3" y1="13" x2="7" y2="9" /><line x1="13" y1="3" x2="9" y2="7" />
  </svg>
);

export const IconCSV = () => (
  <svg viewBox="0 0 16 16" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round">
    <path d="M8 2v8" /><polyline points="5 7 8 10 11 7" />
    <path d="M3 11v2a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1v-2" />
  </svg>
);

export default function CardTools({ onCsv, onExpand }) {
  return (
    <div className="trg-tools">
      {onCsv && (
        <button className="trg-tool" title="Download CSV" onClick={onCsv} type="button">
          <IconCSV />
        </button>
      )}
      {onExpand && (
        <button className="trg-tool" title="Expand" onClick={onExpand} type="button">
          <IconExpand />
        </button>
      )}
    </div>
  );
}

// Fullscreen expand modal (Security Level style). Renders children large + optional CSV.
export function ExpandModal({ open, title, onClose, onCsv, children }) {
  useEffect(() => {
    if (!open) return;
    const h = (e) => { if (e.key === "Escape") onClose(); };
    document.addEventListener("keydown", h);
    return () => document.removeEventListener("keydown", h);
  }, [open, onClose]);
  if (!open) return null;
  return (
    <div className="trg-xmodal-overlay" onClick={(e) => { if (e.target === e.currentTarget) onClose(); }}>
      <div className="trg-xmodal">
        <div className="trg-xmodal-header">
          <div className="trg-xmodal-title">{title}</div>
          <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
            {onCsv && (
              <button className="trg-tool" style={{ position: "static", opacity: 1 }} title="Download CSV" onClick={onCsv} type="button">
                <IconCSV />
              </button>
            )}
            <button className="trg-xmodal-close" onClick={onClose} aria-label="Close" type="button">×</button>
          </div>
        </div>
        <div className="trg-xmodal-body">{children}</div>
      </div>
    </div>
  );
}
